import React, { useMemo } from "react";
import { StyleSheet } from "react-native";
import NtTouchableEffect from "./NtTouchableEffect";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

function NtModalUnactiveButton({ title, containerStyle, onPress }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return (
    <NtTouchableEffect style={[styles.container, containerStyle]} onPress={onPress}>
      <NtText style={styles.title}>{title}</NtText>
    </NtTouchableEffect>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      borderRadius: t.radius,
      borderWidth: 1,
      borderColor: t.border,
      backgroundColor: t.surface2,
      paddingHorizontal: 12,
      paddingVertical: 8,
      alignItems: "center",
      justifyContent: "center",
    },
    title: { fontSize: 12, fontWeight: "500", color: t.text },
  });

export default NtModalUnactiveButton;
